import { SettingsTranslationType } from "../../features/settings.types";

export const settings: SettingsTranslationType = {
  settings: {
    title: "Nastavitve",
    aiProvider: {
      label: "Ponudnik umetne inteligence",
      select: "Izberi ponudnika",
      description: "Izberite ponudnika umetne inteligence za generiranje zgodb",
      updateSuccess: "Ponudnik UI posodobljen",
      updateSuccessDesc: "Vaša nastavitev ponudnika UI je bila shranjena",
      updateError: "Posodobitev ni uspela",
      updateErrorDesc: "Posodobitev ponudnika UI ni uspela. Poskusite znova."
    },
    language: {
      label: "Jezik",
      description: "Izberite svoj želeni jezik vmesnika"
    },
    subscription: {
      title: "Naročnina",
      currentPlan: "Trenutni Paket",
      freeTier: "Brezplačno",
      basicTier: "Osnovno",
      premiumTier: "Premium",
      status: "Status",
      renewalDate: "Datum obnovitve",
      upgradePlan: "Nadgradi paket",
      managePlan: "Upravljaj paket",
      cancelPlan: "Prekliči paket",
      features: "Funkcije",
      billingCycle: "Obračunsko obdobje",
      monthlyLabel: "Mesečno",
      yearlyLabel: "Letno",
      priceUnits: {
        month: "mesec",
        year: "leto"
      },
      tiers: {
        free: {
          name: "Brezplačno",
          description: "Osnovne funkcije za začetek",
          price: "Brezplačno"
        },
        basic: {
          name: "Osnovno",
          description: "Napredne funkcije za ljubiteljske pisatelje",
          price: {
            monthly: "9,99 €/mesec",
            yearly: "99 €/leto"
          }
        },
        premium: {
          name: "Premium",
          description: "Popoln dostop za profesionalne pisatelje",
          price: {
            monthly: "19,99 €/mesec",
            yearly: "199 €/leto"
          }
        }
      },
      browseCharacters: "Prebrskaj like",
      upgradeToBrowse: "Nadgradi za pregled vaše zbirke likov",
      upgradeToMakePublic: "Nadgradi za javno objavo likov",
      upgradeRequired: "Potrebna je nadgradnja",
      upgradeToBrowseDescription: "Nadgradite svoj račun za pregled in ponovno uporabo vaše zbirke likov.",
      upgradeToMakePublicDescription: "Nadgradite svoj račun za javno deljenje likov z drugimi uporabniki.",
      unlockFeatures: "Odklenite premium funkcije z naročnino",
      upgradeNow: "Nadgradi zdaj",
      unlockAiTitleGeneration: "Odklenite Generiranje Naslovov z UI",
      upgradeForCharaterAccess: "Nadgradite za dostop do upravljanja likov",
      upgradeForStatsAccess: "Nadgradite za dostop do statistike in značk",
      upgradeForAccess: "Nadgradite za dostop do te funkcije",
      upgradeForAiTitleDescription: "Nadgradite na Osnovni paket za dostop do generiranja naslovov s pomočjo umetne inteligence in pridobite kreativne predloge na podlagi tem, likov in okolja vaše zgodbe.",
      generateTitlesFeature: "Takoj ustvarite edinstvene naslove",
      aiTitleGenerationPremium: "Generiranje Naslovov z UI je na voljo v Osnovnem paketu",
      unlockGenre: "Nadgradite za odklepanje tega žanra",
      unlockCustomGenres: "Odklenite Prilagojene Žanre",
      upgradeForCustomGenresDescription: "Nadgradite na Osnovni paket za ustvarjanje prilagojenih žanrov in naredite svoje zgodbe bolj edinstvene.",
      addCustomGenresFeature: "Dodajte neomejeno število prilagojenih žanrov",
      unlockEnvironment: "Nadgradite za odklepanje tega okolja",
      upgradeForCustomEnvironments: "Nadgradite na TaleCraft Basic za dodajanje prilagojenih okolij",
      unlockCustomEnvironments: "Odklenite Prilagojena Okolja",
      upgradeForCustomEnvironmentsDescription: "Nadgradite na Osnovni paket za ustvarjanje prilagojenih okolij in naredite svoje zgodbe bolj edinstvene.",
      addCustomEnvironmentsFeature: "Dodajte neomejeno število prilagojenih okolij",
      unlockTheme: "Nadgradite za odklepanje te teme",
      upgradeForCustomThemes: "Nadgradite na TaleCraft Basic za dodajanje prilagojenih tem",
      unlockCustomThemes: "Odklenite Prilagojene Teme",
      upgradeForCustomThemesDescription: "Nadgradite na Osnovni paket za ustvarjanje prilagojenih tem in naredite svoje zgodbe bolj edinstvene.",
      addCustomThemesFeature: "Dodajte neomejeno število prilagojenih tem",
      unlockStoryLength: "Nadgradite za odklepanje te dolžine zgodbe",
      upgradeForPremiumLengths: "Nadgradite na TaleCraft Basic za dostop do daljših zgodb",
      unlockPremiumLengths: "Odklenite Premium Dolžine Zgodb",
      upgradeForPremiumLengthsDescription: "Nadgradite na Premium paket za ustvarjanje daljših zgodb in razvijanje pripovedi z več podrobnostmi.",
      longStoriesFeature: "Ustvarite zgodbe brez omejitev dolžine",
      avatarGenerator: {
        upgradeRequired: "Potrebna je nadgradnja",
        upgradeDescription: "Nadgradite svoj račun za generiranje avatarjev likov.",
        premiumFeature: "Ustvarjajte prilagojene avatarje likov s premium naročnino",
        upgradeNow: "Nadgradi zdaj",
        upgradeTooltip: "Nadgradi za generiranje avatarjev likov"
      },
      planComparison: {
        chooseYourPlan: "Izberite paket, ki najbolj ustreza vašim potrebam",
        price: "Cena",
        features: "Funkcije",
        talecraftBasic: "TaleCraft Basic",
        talecraftPremium: "TaleCraft Premium",
        savePercentage: "Prihranite 17%",
        currentPlanLabel: "Trenutni paket:",
        processing: "Obdelava...",
        downgradeToBasic: "Znižajte na TaleCraft Basic",
        downgradeToFree: "Znižajte na Brezplačni paket",
        upgradeToBasic: "Nadgradite na TaleCraft Basic",
        upgradeToPremium: "Nadgradite na TaleCraft Premium",
        downgradingTo: "Znižanje na",
        effectiveOn: "Velja od",
        nextBillingDate: "Naslednji datum obračuna",
        featureItems: {
          dailyStoryLimit: "Dnevna omejitev zgodb",
          aiStoryGeneration: "Generiranje zgodb z UI",
          customResponses: "Prilagojeni odgovori",
          aiTitleSuggestion: "Predlogi naslovov z UI",
          customStorySelection: "Izbira prilagojenih zgodb",
          publicSharing: "Javna objava",
          characterManagement: "Upravljanje likov",
          aiProviderSelection: "Izbira ponudnika UI",
          statsAndBadges: "Statistika in značke/razvrščanje",
          badgeRewards: "Nagrade značk",
          naturalStoryLength: "Naravna dolžina zgodbe",
          sequelsAndExtract: "Nadaljevanja in izvleček likov",
          characterAvatar: "Avatar lika",
          earlyAccessFeatures: "Funkcije predčasnega dostopa"
        },
        limits: {
          perDay: "/dan",
          unlimited: "Neomejeno"
        }
      }
    },
    profile: {
      displayName: {
        label: "Prikazno Ime",
        placeholder: "Vnesite svoje prikazno ime",
        updateButton: "Posodobi Ime",
        helpText: "Izberite edinstveno prikazno ime za svoj profil"
      },
      inviteFriends: {
        label: "Povabi Prijatelje",
        button: "Povabi Prijatelje",
        dialogTitle: "Deli Povabilo",
        dialogDescription: "Povabite svoje prijatelje, da se vam pridružijo na vašem pripovednem potovanju. Delite svojo edinstveno povezavo za povabilo ali uporabite družbena omrežja.",
        copySuccess: {
          title: "Povezava kopirana!",
          description: "Referenčna povezava je bila kopirana v odložišče."
        },
        copyFailure: {
          title: "Kopiranje ni uspelo",
          description: "Poskusite povezavo kopirati ročno."
        },
        shareMessage: "Pridruži se mi na našem pripovednem potovanju! Skupaj ustvarjajmo in delimo neverjetne zgodbe.",
        socialPlatforms: {
          facebook: "Facebook",
          X: "X",
          linkedin: "LinkedIn",
        }
      },
      upgradeDialog: {
        title: "Potrebna je Nadgradnja",
        aiProviderDescription: "Nadgradite za izbiro ponudnika UI.",
        unlockProviderSelection: "Odklenite izbiro ponudnika UI z naročnino"
      }
    },
    issues: {
      title: "Prijavite težavo",
      description: "Ste našli napako ali imate predlog? Sporočite nam!",
      submitSuccess: "Težava prijavljena",
      submitSuccessDesc: "Hvala za vaše povratne informacije. Pregledali bomo težavo.",
      submitError: "Pošiljanje ni uspelo",
      submitErrorDesc: "Pri prijavi težave je prišlo do napake. Poskusite znova kasneje.",
      form: {
          titleLabel: "Naslov",
          titlePlaceholder: "Kratek opis težave",
          descriptionLabel: "Opis",
          descriptionPlaceholder: "Prosimo, navedite podrobnosti o težavi...",
          priorityLabel: "Prioriteta",
          priorityPlaceholder: "Izberite prioriteto",
          priorityLow: "Nizka",
          priorityMedium: "Srednja",
          priorityHigh: "Visoka",
          priorityDescription: "Izberite nujnost te težave, da nam pomagate pri pravilni prioritizaciji.",
          submit: "Pošlji prijavo",
          submitting: "Pošiljanje...",
          imagesLabel: "Priložite slike",
          typeLabel: "Vrsta težave",
          typePlaceholder: "Izberite vrsto težave",
          typeBug: "Napaka",
          typeRequest: "Zahteva",
          typeDescription: "Izberite vrsto težave, ki jo prijavljate",
        },
        imageUpload: {
          dragDrop: "Prevlecite in spustite slike sem",
          dropHere: "Spustite slike sem...",
          clickToSelect: "ali kliknite za izbiro datotek",
          maxSize: "Največ 5MB na datoteko",
          maxNumber: "Največ 5 slik",
          attachedImages: "Priložene slike",
          invalidFiles: "Nekatere datoteke niso bile sprejete",
          sizeTypeLimit: "Datoteke morajo biti slike pod 5MB",
          tooManyImages: "Preveč slik",
          limitReached: "Lahko priložite največ 5 slik",
          pasteSupported: "Podprto lepljenje slik",
          pasteSuccess: "Slika prilepljena",
          pasteSuccessDesc: "Slika iz odložišča je bila priložena",
          pasteFailed: "Prilepljenje slike ni uspelo",
          pasteFailedDesc: "Ni bilo mogoče obdelati vsebine odložišča",
          processing: "Obdelava slike...",
        },
    },
  }
};
